/**
 * @generated SignedSource<<2e2957b93f2621deb6af92f10bb29a72>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type timeline_nativeIssueTable_TimelineCellRenderer_fieldRef$data = {
  readonly " $fragmentSpreads": FragmentRefs<"timelineCell_issueTableTimelineUI_fieldRef">;
  readonly " $fragmentType": "timeline_nativeIssueTable_TimelineCellRenderer_fieldRef";
};
export type timeline_nativeIssueTable_TimelineCellRenderer_fieldRef$key = {
  readonly " $data"?: timeline_nativeIssueTable_TimelineCellRenderer_fieldRef$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeline_nativeIssueTable_TimelineCellRenderer_fieldRef">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "timeline_nativeIssueTable_TimelineCellRenderer_fieldRef",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "timelineCell_issueTableTimelineUI_fieldRef"
        }
      ]
    }
  ],
  "type": "JiraIssueField",
  "abstractKey": "__isJiraIssueField"
};

(node as any).hash = "a4d912e975bbf314316410e10312acb3";

export default node;
